import React from "react"
import { Container, Row } from "react-bootstrap"
import Post from "./Post"
import BannerCategory from "../BannerCategory"
import LatestPosts from "../LatestPosts"
import NavBlog from "../NavBlog"
import FooterBanner from "../FooterBanner"
import PopularCategory from "../PopularCategory"
import PillarBanner from "../PillarBanner"

const Posts = ({ categoryPosts }) => {
  return (
    <>
      <NavBlog />
      <BannerCategory title={categoryPosts[0].category} />
      <PillarBanner category={categoryPosts[0].category} />
      <LatestPosts recentPosts={categoryPosts} />
      {categoryPosts.find(item => item.isPopular) && (
        <div className="container">
          <PopularCategory category={categoryPosts[0].category} number={4} />
        </div>
      )}
      <div className="d-lg-flex d-block cat-d">
        <div className="stroke-heading explore">EXPLORE</div>
        <div>
          <h1 className="rb e-h1 ms-3 ms-lg-0">Explore More Articles</h1>
        </div>
      </div>
      <Container className="category-posts" id="#explore">
        <Row>
          {categoryPosts.map(item => (
            <Post item={item} key={item.id} />
          ))}
        </Row>
      </Container>
      <FooterBanner />
    </>
  )
}

export default Posts
